import { useEffect, useRef, useState } from 'react';

const BASE = `${process.env.PUBLIC_URL}/assets/video`;

/**
 * Vídeo do hero. Cada página v2 roda a sua própria simulação de verbas —
 * `nome` escolhe o filme (sim-home, sim-cobrar, sim-aconteceu, sim-recuperar).
 *
 * Corte 9:16 no celular: o 16:9 numa tela de 390px vira uma tarja de 220px e
 * os números do vídeo ficam ilegíveis, que é justamente o conteúdo. Decidido
 * na montagem porque <source media> não é confiável entre navegadores.
 *
 * Decorativo: sem som, sem controles, fora da ordem de leitura. Quem pediu
 * menos movimento no sistema vê só o pôster — autoplay em loop é exatamente
 * o que a preferência "reduzir movimento" existe para evitar.
 */
export const HeroVideo = ({ nome = 'sim-home', className = '' }) => {
  const videoRef = useRef(null);
  const [semMovimento, setSemMovimento] = useState(false);
  const [vertical, setVertical] = useState(false);

  useEffect(() => {
    const movimento = window.matchMedia('(prefers-reduced-motion: reduce)');
    const estreito = window.matchMedia('(max-width: 767px)');
    const aplicar = () => {
      setSemMovimento(movimento.matches);
      setVertical(estreito.matches);
      if (movimento.matches && videoRef.current) videoRef.current.pause();
    };
    aplicar();
    movimento.addEventListener('change', aplicar);
    estreito.addEventListener('change', aplicar);
    return () => {
      movimento.removeEventListener('change', aplicar);
      estreito.removeEventListener('change', aplicar);
    };
  }, []);

  const corte = vertical ? '9x16' : '16x9';
  const arquivo = `${BASE}/${nome}-${corte}`;
  const poster = `${arquivo}-poster.jpg`;

  return (
    <figure
      className={`relative w-full ${vertical ? 'max-w-[300px]' : 'max-w-2xl'} mx-auto rounded-2xl overflow-hidden border border-white/15 shadow-2xl shadow-black/50 ${className}`}
    >
      {semMovimento ? (
        <img src={poster} alt="Simulação ilustrativa de verbas não pagas" className="w-full block" />
      ) : (
        <video
          key={arquivo}
          ref={videoRef}
          className="w-full block"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={poster}
          aria-label="Simulação ilustrativa de verbas não pagas"
        >
          <source src={`${arquivo}.mp4`} type="video/mp4" />
        </video>
      )}
      <figcaption className="absolute bottom-0 inset-x-0 bg-black/70 text-[10px] sm:text-xs text-center text-white/80 py-1.5 px-2 font-mono">
        simulação ilustrativa · não é promessa de resultado
      </figcaption>
    </figure>
  );
};
